import React, { useState, useContext } from "react";
import Sidebar from "./Comman/Sidebar";
import Header from "./Comman/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { OnmaxContext } from "../OnmaxContext";

export default function NewPassword() {
  const username = localStorage.getItem("username");
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useContext(OnmaxContext);
  const [contactNo, setContactNo] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateContact = async (e) => {
    e.preventDefault();

    if (!contactNo) {
      toastError("Enter your Email");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactNo)) {
      toastError("Enter a valid email address");
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "changepassword",
        email: contactNo,
        password: password,
        username: username,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data.resCode === 200) {
        toastSuccess(res.data.message || "Your Password Is Changed!");
        localStorage.setItem("email", contactNo);
        setTimeout(() => navigate("/dashboard"), 2000); 
      } else {
        toastError(res.data.message || "Error updating Password");
      }
    } catch (error) {
      toastError(error.response?.data?.message || "Server Error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; font-weight: 500;}

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 16px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      margin-bottom: 24px;
    }
    .db-input-wrapper.disabled { background: #f8fafc; opacity: 0.7; box-shadow: none; }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 12px;
      font-weight: 700; width: 100%; font-size: 16px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.3); transition: 0.3s;
      margin-top: 10px;
    }
    .db-modern-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 111, 227, 0.4); }
    .db-modern-btn:disabled { opacity: 0.7; cursor: not-allowed; }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Sidebar />
        <Header />
        <section className="nftmax-adashboard nftmax-show">
          <div className="ai-auth-container">
            <div className="ai-auth-card">
              <h2 className="ai-title">New Password</h2>
              <p className="ai-subtitle">Enter your new security credentials</p>

              <form onSubmit={updateContact}>
                <label className="text-secondary small fw-bold ms-1 mb-1">Username</label>
                <div className="db-input-wrapper disabled">
                  <i className="fa fa-user" style={{ color: '#006fe3' }}></i>
                  <input className="db-input" value={username || ''} disabled />
                </div>

                <label className="text-secondary small fw-bold ms-1 mb-1">Confirm Email</label>
                <div className="db-input-wrapper">
                  <i className="fa fa-envelope" style={{ color: '#006fe3' }}></i>
                  <input
                    className="db-input"
                    type="email"
                    placeholder="Enter Email"
                    value={contactNo}
                    onChange={(e) => setContactNo(e.target.value)}
                    required
                  />
                </div>

                <label className="text-secondary small fw-bold ms-1 mb-1">New Password</label>
                <div className="db-input-wrapper">
                  <i className="fa fa-lock" style={{ color: '#006fe3' }}></i>
                  <input
                    className="db-input"
                    type="password"
                    placeholder="Enter New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="db-modern-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Updating..." : "Set New Password"}
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
